import React from 'react';
import { withRouter } from 'react-router-dom';

import styles from './ContactItem.module.css';
import Content from './Content';

const NewsItem = (props) => {
  return(
    <div className={styles.ContactItem}>
      <div className={styles.wrapper}>
        <Content post ={props.post} />
      </div>
    </div>
  );
}

export default withRouter(NewsItem);
